
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/singular",
      function () {
        return require("private-next-pages/destinations/singular.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/singular"])
      });
    }
  